<template>
    <div class="login">
      <!-- 导航栏区域 -->
      <van-nav-bar class="nav_bar" title="注册" placeholder fixed @click-left="$router.go(-1)">
        <template slot="left">
          <van-icon class="left_arrow" name="arrow-left" />
        </template>
      </van-nav-bar>
      <!-- 导航栏区域 -->
      <!-- 表单区域 -->
      <van-form @submit="registeredUser" ref="loginFromRef">
        <van-field v-model="loginForm.username" placeholder="请输入用户名"  :rules="loginFormRoles.username">
          <i slot="left-icon" class="iconfont icon-yonghu"></i>
        </van-field>
        <van-field v-model="loginForm.password" placeholder="请输入密码" type="password"  :rules="loginFormRoles.password">
          <i slot="left-icon" class="iconfont icon-Password"></i>
        </van-field>
        <van-field v-model="loginForm.mobile" placeholder="请输入手机号" :rules="loginFormRoles.mobile" type="number" name="mobile">
          <i slot="left-icon" class="iconfont icon-shoujihao"></i>
        </van-field>
        <van-field v-model="loginForm.code" placeholder="请输入验证码" :rules="loginFormRoles.code" type="number" name="code">
          <i slot="left-icon" class="iconfont icon-ecurityCode"></i>
          <template #button>
            <!-- 倒计时 -->
            <van-count-down v-if="isCountDownShow" :time="1000 * 60" format="ss 秒后重试" ref="countDown" @finish="isCountDownShow = false" />
            <van-button v-else size="small" round @click="sendCode" native-type="button">发送验证码</van-button>
          </template>
        </van-field>
        <van-button block class="login-btn" native-type="submit">注册</van-button>
        <div class="secondary-btns">
           <van-button plain block class="secondary-btn" @click="$router.push('/Login')">登录</van-button>
           <van-button plain block class="secondary-btn" @click="$router.push('/Reset')">找回密码</van-button>
         </div>
      </van-form>
    </div>
</template>

<script>
import { registeredUser, sendSms } from '@/api/Login/Registered'
import { getItem, setItem } from '../../utils/localStorage'
export default {
  name: 'Registered',
  data() {
    return {
      // 登录表单数据
      loginForm: {
        username: '',
        password: '',
        email: '',
        mobile: '',
        nickname: '',
        idcard: '',
        code: ''
      },
      // 控制倒计时组件与发送验证码按钮的显示与隐藏
      isCountDownShow: false,
      // 登录表单验证队则
      loginFormRoles: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'onBlur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'onBlur' }
        ],
        nickname: [
          { required: true, message: '请输入姓名', trigger: 'onBlur' }
        ],
        idcard: [
          { required: true, message: '请输入身份证号', trigger: 'onBlur' }
        ],
        // 手机
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'onBlur' },
          { pattern: /^1[3|4|5|7|8|9][0-9]{9}$/, message: '请输入正确的手机号' }
        ],
        // 验证码
        code: [
          { required: true, message: '请输入验证码', trigger: 'onBlur' },
          { pattern: /^[0-9]{4}$/, message: '请输入正确的验证码(验证码为4位)' }
        ]
      }
    }
  },
  mounted() {
    // 判断是否登录
    this.determineLogin()
  },
  methods: {
    // 判断是否登录
    determineLogin() {
      if (getItem('token')) {
        this.$router.push('/index')
      }
    },
    // 发送验证码
    async sendCode() {
      // 验证手机号
      await this.$refs.loginFromRef.validate('mobile')
      await sendSms(this.loginForm.mobile)
      // 显示倒计时组件  隐藏发送验证码按钮
      this.isCountDownShow = true
    },
    // 表单submit事件
    async registeredUser() {
      this.$toast.loading({
        message: '注册中...',
        forbidClick: true, // 禁用点击背景
        duration: 0 // 持续显示
      })
      const res = await registeredUser(this.loginForm)
      if (res.code !== 1) {
        this.$toast.fail(res.msg)
      } else {
        setItem('token', res.data.userinfo.token)
        this.$toast.success('注册成功')
        this.$router.push('/index')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.login {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
  width: 100%;
  background-size: cover;
  background: url('../../assets/images/loginbg2.jpg'); /* 背景图路径，请根据实际情况修改 */
  background-size: cover; /* 背景图覆盖整个容器 */
  background-position: center; /* 背景图居中显示 */
  background-repeat: no-repeat; /* 背景图不重复 */
  .van-form {
    position: absolute;
    top: 52%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 600px;
    padding: 30px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    // 输入框
    .van-field {
      height: 90px;
      padding: 0;
      display: flex;
      align-items: center;
      .iconfont {
        font-size: 37px;
        color: #666666;
        margin: 0 40px;
      }
      .van-button {
        // 发送验证码按钮
        font-size: 22px;
        color: #7e7d7e;
        background-color: #eeedef;
        border: 0;
        margin-right: 34px;
        margin-bottom: 15px;
        width: 152px;
        height: 46px;
        line-height: 46px;
      }
      .van-count-down {
        // 倒计时组件
        font-size: 22px;
        margin-right: 34px;
        width: 152px;
        height: 46px;
        line-height: 46px;
        text-align: center;
      }
    }
    .van-field:nth-child(2)::after {
      // 第二个输入框
      border: 0;
    }
    .login-btn {
      display: block;
      margin: 30px auto 0;
      width: calc(100% - 40px); /* 减去左右padding */
      max-width: 300px;
      // 登录按钮
      height: 88px;

      margin-top: 63px;
      border-radius: 10px;
      background-color: #6db4fb;
      border: 0;
      font-size: 30px;
      color: #fff;
    }
    /* 修改次级按钮样式为居中排列 */
    .secondary-btns {
      display: flex;
      justify-content: center; /* 改为居中排列 */
      width: calc(100% - 40px);
      max-width: 300px;
      margin: 15px auto 0;
      gap: 20px; /* 添加按钮间距 */

      .secondary-btn {
        flex: 0 1 auto; /* 取消等分，自动宽度 */
        width: auto; /* 自动宽度 */
        min-width: 120px; /* 最小宽度 */
        height: 65px;
        font-size: 24px;
        color: #666;
        background: transparent;
        border: 1px solid #ddd;
        border-radius: 8px;
        padding: 0 20px; /* 添加内边距 */
      }
    }
    /deep/.van-field--error .van-field__control::-webkit-input-placeholder {
        color: #c8c9cc!important;
        -webkit-text-fill-color: #c8c9cc!important;
    }

    /deep/.van-field--error .van-field__control,.van-field--error .van-field__control::placeholder {
        color: #c8c9cc!important;
        -webkit-text-fill-color: #c8c9cc!important;
    }
  }
}

</style>
